// extracted by mini-css-extract-plugin
export default {"container":"profile_container__V7xUs","name":"profile_name__2f0qN","icon":"profile_icon__2f2Fn"};